import React, { FC, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { IPnrCar, IPnrService, IPnrTransfer } from "../../interfaces/IPnr";
import { api } from "../../services/api";
import Logger from "../../services/Logger";
import { pnrTKey } from "../../utils/helpers";
import { Busy } from "../snippets/Busy";
import TransferCard from "../TransferCard";
import PnrHistory from "./PnrHistory";
import PnrPayment from "./PnrPayment";
import PnrPeople from "./PnrPeople";

interface IProps {
  pnr: IPnrTransfer;

  reload(pnr: IPnrTransfer): any;
  updatePnr(pnr: string, status: string): void;
}

const PnrTransfer: FC<IProps> = ({ pnr, reload, updatePnr }) => {
  const { t } = useTranslation();
  const [isBusy, setIsBusy] = useState(false);

  const reloadHandler = useCallback(async () => {
    setIsBusy(true);
    await reload(pnr);
    setIsBusy(false);
  }, [pnr, reload]);

  const pnrAction = useCallback(
    async (service: IPnrService) => {
      setIsBusy(true);
      const log = new Logger(t(`pnr.${pnrTKey(service.uri)}Pending`));
      try {
        const { data } = await api().post(service.uri, pnr);
        if (data.errors.error) {
          log.error(data.errors.error);
        } else {
          log.success(t(`pnr.${pnrTKey(service.uri)}Success`));
          updatePnr(pnr.pnr, pnr.status);
          await reloadHandler();
        }
      } catch (e) {
        log.error(e);
      }
      setIsBusy(false);
    },
    [pnr, reloadHandler, t, updatePnr]
  );

  return (
    <div className="pnr-list-scroll-area">
      {isBusy && <Busy />}
      <div className="pnr-details details">
        <div className="pnr-details-footer">
          {pnr.services &&
            pnr.services.map(s => (
              <button key={s.title} onClick={() => pnrAction(s)}>
                <span>{t(`button.${pnrTKey(s.uri)}`)}</span>
              </button>
            ))}
          <span className="fill-space" />
        </div>
        <div className="flex j-between">
          <div>
            <span className="c-primary">
              <span className="text fs-med">PNR:</span> <span className="text bold">{pnr.pnr}</span>
            </span>
          </div>
          <div>
            <p className="c-primary pnr-status">
              <span className="text fs-med">{t("generic.status").toUpperCase()}:</span>
              <span className={pnr.status ? pnr.status.toLowerCase() : ""}>&nbsp;{pnr.status}</span>
            </p>
            <p className="c-primary fs-std align-right">
              <span>{t("generic.source")}:</span>
              {pnr.source}
            </p>
          </div>
        </div>
        <div className="activity-container">
          <TransferCard transfer={pnr.offer} />
        </div>
      </div>
      <PnrPayment payments={pnr.payment} />
      {pnr.offer && <PnrPeople pnr={pnr as IPnrCar} />}
      <PnrHistory pnr={pnr} />
    </div>
  );
};

export default PnrTransfer;
